var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "guideLine", role: "dialog" },
      on: {
        click: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog modal-xl",
          on: {
            click: function($event) {
              $event.stopPropagation()
            }
          }
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "modal-footer flexbox justify-right" }, [
              _c(
                "div",
                {
                  attrs: { "data-dismiss": "modal" },
                  on: {
                    click: function($event) {
                      _vm.$emit("close")
                    }
                  }
                },
                [
                  _c("button", { staticClass: "btn ver-middle w-120" }, [
                    _vm._v("閉じる")
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", { staticClass: "text-size-20 font-bold" }, [
        _vm._v("だれでも掲示板 ガイドライン")
      ]),
      _vm._v(" "),
      _c("div", [
        _vm._v(
          "\n          以下の行為が見られた場合、投稿が削除されることがあります。"
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n          1. 侮辱、個人攻撃、悪意のある発言、卑猥な言葉、口汚い罵り、嫌がらせ、虐待、中傷、扇動的な発言など、無礼と見なされる可能性のある内容。"
        ),
        _c("br"),
        _vm._v(
          "\n          2. 人種、民族、国籍、性別、性自認、性的指向、宗教、年齢、身体障害などの特徴に基づく差別的または憎悪に満ちた内容。"
        ),
        _c("br"),
        _vm._v(
          "\n          3. 安全のため、電話番号、Eメールアドレス、個人住所、免許証番号、社会保障番号、銀行口座番号、クレジットカード番号、デビットカード番号、金融情報、IPアドレスなどの個人情報を記載しないでください。"
        ),
        _c("br"),
        _vm._v(
          "\n          4. 政治家候補、政党、政策に関する意見や発言などを含む政治的な内容。"
        ),
        _c("br"),
        _vm._v(
          "\n          5. 同じ投稿を複数回コピーして貼り付ける、迷惑なリンクを投稿するなど、スパムと見なされる可能性のある内容。"
        ),
        _c("br"),
        _vm._v("\n          6. 他のセラーまたは団体になりすます行為。"),
        _c("br"),
        _vm._v("\n          7. 自社商品を売り込む行為。"),
        _c("br"),
        _vm._v(
          "\n          8. 著作権、商標権、特許権、企業秘密などの知的財産権やその他の所有権を侵害する、または侵害する可能性のある内容。"
        ),
        _c("br"),
        _vm._v(
          "\n          9. その他、ご利用にあたり不適切であると当社が合理的な根拠に基づき判断する内容。"
        ),
        _c("br"),
        _c("br"),
        _vm._v(
          "\n\n          以上のガイドラインを守り、皆様が安全で快適にご利用いただけるようご協力をお願いします。\n        "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e5b1ec2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e5b1ec2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/request/GuideLine.vue
// module id = null
// module chunks = 